// useBackButtonHandler.js
import { useEffect } from 'react';
import { BackHandler } from 'react-native';
import { useDispatch } from 'react-redux';
import { setBookModalVisibility } from '../../reducers/configSlice';

import {isIOS, isWEB} from "../helpers/getPlatformType";

export const useBackButtonHandler = () => {
    if (isIOS() || isWEB()) {
        return;
    }

    const dispatch = useDispatch();

    useEffect(() => {
        const backHandler = BackHandler.addEventListener('hardwareBackPress', () => {
            dispatch(setBookModalVisibility(false));
            return true;
        });

        return () => backHandler.remove();
    }, [dispatch]);
};
